import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);

const routes = [
  { path: '/', redirect: '/key-recharge' },
  { path: '/key-recharge', name: 'KeyRecharge', component: () => import('@/views/c/KeyRecharge.vue'), meta: { title: '密钥充值', requireAuth: false } },
  { path: '/wechat-recharge', name: 'WechatRecharge', component: () => import('@/views/c/WechatRecharge.vue'), meta: { title: '微信充值', requireAuth: false } },
  { path: '/admin/login', name: 'Login', component: () => import('@/views/b/Login.vue'), meta: { title: '管理员登录', requireAuth: false } },
  {
    path: '/order-history',
    name: 'OrderHistory',
    component: () => import('@/views/c/OrderHistory.vue'),
    meta: { title: '充值历史', requireAuth: false }
  },
  {
    path: '/wechat-pay',
    name: 'WechatPay',
    component: () => import('@/views/c/WechatPay.vue'),
    meta: { title: '微信支付', requireAuth: false }
  },
  {
    path: '/admin',
    component: () => import('@/components/Layout/BLayout.vue'),
    meta: { requireAuth: true },
    children: [
      { path: '', redirect: 'dashboard' },
      { path: 'dashboard', name: 'Dashboard', component: () => import('@/views/b/Dashboard.vue'), meta: { title: '仪表盘' } },
      { path: 'orders', name: 'OrderManage', component: () => import('@/views/b/OrderManage.vue'), meta: { title: '订单管理' } },
      { path: 'packages', name: 'PackageManage', component: () => import('@/views/b/PackageManage.vue'), meta: { title: '套餐管理' } },
      { path: 'keys', name: 'KeyManage', component: () => import('@/views/b/KeyManage.vue'), meta: { title: '密钥管理' } },
      { path: 'customers', name: 'CustomerManage', component: () => import('@/views/b/CustomerManage.vue'), meta: { title: '客户管理' } },
      {
        path: 'ai-query',
        name: 'AiQuery',
        component: () => import('@/views/ai/AiQuery.vue'),
        meta: { title: 'AI小助手' }
      }
    ]
  },
  { path: '*', component: () => import('@/views/404.vue') }
];

const router = new VueRouter({ mode: 'history', routes });

router.beforeEach((to, from, next) => {
  if (to.meta.title) document.title = to.meta.title + ' - 流量充值平台';
  if (to.meta.requireAuth) {
    const token = localStorage.getItem('admin_token');
    if (!token) next({ path: '/admin/login', query: { redirect: to.fullPath } });
    else next();
  } else {
    next();
  }
});

export default router;